import { render, staticRenderFns } from "./AddInvoiceServices.vue?vue&type=template&id=8517e682&"
import script from "./AddInvoiceServices.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports